import DocumentsAPI from './documents';

// Ticket-scoped file-document singleton.
// Owner id is the ticket display_id (the URL identifier for nested ticket routes).
export default new DocumentsAPI('tickets');
